import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Alert, Box, Snackbar, Stack, TextField, Typography } from '@mui/material';
import { FlowBreadcrumbs, FlowFormCard, SubmitButton, mediaPreviewStyles } from './FlowLayout';
import { fetchDestinationHierarchy } from './flowHierarchy';

const AddGallery = () => {
  const { destinations_id } = useParams();
  const navigate = useNavigate();
  const [hierarchy, setHierarchy] = useState({
    destinationName: '',
    tourTypeId: '',
    tourTypeName: '',
    continentId: '',
    continentName: ''
  });
  const [src, setSrc] = useState(null);
  const [srcPreview, setSrcPreview] = useState(null);
  const [alt, setAlt] = useState('');
  const [imageOrder, setImageOrder] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  React.useEffect(() => {
    fetchDestinationHierarchy(destinations_id)
      .then((response) => setHierarchy(response))
      .catch((error) => console.error('There was an error fetching the destination context!', error));
  }, [destinations_id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const formData = new FormData();
    formData.append('destinations_id', destinations_id);
    formData.append('type', 'img');
    formData.append('src', src);
    formData.append('alt', alt);
    formData.append('image_order', imageOrder);

    try {
      await axios.post('https://aaryanholidays.in/backend/gallery', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setSnackbar({ open: true, message: 'Gallery item added successfully.', severity: 'success' });
      navigate(`/manage-destination/gallery/${destinations_id}`);
    } catch (error) {
      console.error('There was an error adding the gallery item!', error);
      setSnackbar({ open: true, message: 'There was an error adding the gallery item.', severity: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <FlowBreadcrumbs items={[{ label: 'Tour Management', to: '/manage-continents' }, { label: hierarchy.continentName || 'Continent', to: hierarchy.continentId ? `/manage-tour-type/${hierarchy.continentId}` : undefined }, { label: hierarchy.tourTypeName || 'Country', to: hierarchy.tourTypeId ? `/manage-destination/${hierarchy.tourTypeId}` : undefined }, { label: hierarchy.destinationName || 'Package', to: hierarchy.tourTypeId ? `/manage-destination/${hierarchy.tourTypeId}` : undefined }, { label: 'Gallery', to: `/manage-destination/gallery/${destinations_id}` }, { label: 'Add Media' }]} />
      <FlowFormCard title="Add Gallery Media" subtitle="Upload clean destination media with alt text and ordering so the gallery stays easy to curate.">
        <form onSubmit={handleSubmit}>
          <Stack spacing={2.5}>
            <Box>
              <input id="gallery-upload" type="file" hidden accept="image/*" onChange={(e) => {
                const file = e.target.files[0];
                setSrc(file);
                setSrcPreview(file ? URL.createObjectURL(file) : null);
              }} />
              <label htmlFor="gallery-upload">
                <SubmitButton component="span" variant="outlined">
                  Upload Image
                </SubmitButton>
              </label>
            </Box>
            {srcPreview ? (
              <Box>
                <Typography variant="body2" sx={{ mb: 1, color: '#64748b' }}>Preview</Typography>
                <img src={srcPreview} alt="Gallery preview" style={mediaPreviewStyles} />
              </Box>
            ) : null}
            <TextField label="Alt Text" value={alt} onChange={(e) => setAlt(e.target.value)} fullWidth required />
            <TextField label="Image Order" value={imageOrder} onChange={(e) => setImageOrder(e.target.value)} fullWidth required />
            <SubmitButton type="submit" variant="contained" loading={submitting}>
              Add Media
            </SubmitButton>
          </Stack>
        </form>
      </FlowFormCard>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddGallery;
